import { useMutation } from '@tanstack/react-query';

import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type { ScoutStartFromPromptResponse } from '@/modules/scout-sourcing/types';
import { invalidateQuery } from '@/utils/queries';

type Payload = {
  prompt: string;
  companyId?: string;
};

export const useStartScoutFromPromptMutation = () =>
  useMutation<ScoutStartFromPromptResponse, Error, Payload>({
    mutationFn: ({ prompt, companyId }) =>
      scoutClient.startFromPrompt(prompt, companyId),
    onSettled: () => {
      invalidateQuery(jobsQueryKeys.lists())();
    },
  });
